import React from 'react'
import { Breadcrumbs as BreadcrumbsCore } from 'lib/shared/components'
import { useStoreView } from 'hooks/useStoreView'
import { Wrapper } from './components/Styled'

interface Prop {
  title?: string
}
export const Breadcrumbs: React.FC<Prop> = ({ title }) => {
  const { isLivBrite } = useStoreView()
  return (
    <Wrapper
      isLivBrite={isLivBrite}
    >
      <BreadcrumbsCore
        pageTitle={title}
      />
    </Wrapper>
  )
}
